import { FC, memo, useCallback, useState } from "react";
import { MUTATIONS } from "../../../../graphql";
import { BucketImage } from "../../../../graphql/models";
import { useSnackbarMutation } from "../../../../hooks";
import { i18nForFields } from "../../../../i18n";
import useServiceFormStyle from "./service_form.style";
import {
  ServiceCategory,
  ServiceCategoryGqlCreateResponse,
  ServiceCategoryGqlUpdateResponse,
} from "../types/serviceCategory.type";

import { Button, TextField } from "@material-ui/core";
import { I18NTextField, ImagePicker } from "../../../components";

interface ServiceMacroCatFormProps {
  catEditValue: ServiceCategory | null;
  onToggle: () => void;
  onServiceCategoryCreate: (v: ServiceCategory) => void;
  onServiceCategoryUpdate: (v: ServiceCategory) => void;
}

export const ServiceMacroCatForm: FC<ServiceMacroCatFormProps> = memo(
  function ServiceMacroCatForm({
    catEditValue,
    onToggle,
    onServiceCategoryCreate,
    onServiceCategoryUpdate,
  }) {
    const classes = useServiceFormStyle();

    const [invokeCreateServiceCategory] =
      useSnackbarMutation<ServiceCategoryGqlCreateResponse>(
        MUTATIONS.CREATE_SERVICE_CATEGORY
      );
    const [invokeUpdateServiceCategory] =
      useSnackbarMutation<ServiceCategoryGqlUpdateResponse>(
        MUTATIONS.UPDATE_SERVICE_CATEGORY
      );

    const [i18nFields, setI18nFields] = useState<
      Partial<i18nForFields<"name">>
    >({
      name_en: catEditValue?.i18n?.name_en ?? "",
      name_it: catEditValue?.i18n?.name_it ?? "",
    });
    const [image, setImage] = useState<BucketImage | undefined>(
      catEditValue?.image?.url ? { url: catEditValue.image.url } : undefined
    );
    const [icon, setIcon] = useState<BucketImage | undefined>(
      catEditValue?.icon?.url ? { url: catEditValue.icon.url } : undefined
    );
    const [sortIndex, setSortIndex] = useState<number>(
      catEditValue?.sortIndex ?? 999
    );

    const handleSubmit = useCallback(async () => {
      if (!image?.url || !icon?.url) return;
      if (!i18nFields.name_it && !i18nFields.name_en) return;

      const dto = {
        image: {
          url: image?.url,
        },
        icon: {
          url: icon?.url,
        },
        sortIndex,
        i18n: {
          name_it: i18nFields.name_it ?? "-",
          name_en: i18nFields.name_en ?? "-",
        },
      };

      if (catEditValue) {
        const result = await invokeUpdateServiceCategory({
          variables: {
            updateServiceCategoryId: catEditValue.id,
            dto,
          },
        });

        onServiceCategoryUpdate(result.data!.updateServiceCategory);
      } else {
        const result = await invokeCreateServiceCategory({
          variables: { dto },
        });

        onServiceCategoryCreate(result.data!.createServiceCategory);
      }

      onToggle();
    }, [
      catEditValue,
      i18nFields.name_en,
      i18nFields.name_it,
      icon?.url,
      image?.url,
      invokeCreateServiceCategory,
      invokeUpdateServiceCategory,
      onServiceCategoryCreate,
      onServiceCategoryUpdate,
      onToggle,
      sortIndex,
    ]);

    return (
      <div
        style={{
          padding: "16px 0",
          display: "flex",
          flexDirection: "column",
          gap: 24,
        }}
      >
        <I18NTextField
          required
          i18nFieldName="name"
          className={classes.textField}
          label="Nome"
          variant="outlined"
          value={i18nFields}
          onChange={(e) => setI18nFields(e)}
        />

        <div>
          <p style={{ marginTop: 0 }}>Ordine:</p>
          <TextField
            type="number"
            variant="outlined"
            label="Ordine"
            className={classes.textField}
            value={sortIndex}
            onChange={(e) => setSortIndex(Number.parseInt(e.target.value))}
          ></TextField>
        </div>
        <div>
          <p style={{ marginTop: 0 }}>Immagine Categoria:</p>

          <ImagePicker
            width={"100%"}
            height={100}
            defaultValue={image?.url}
            onUploaded={(entry) =>
              setImage({
                url: entry.url,
              })
            }
          />
        </div>
        <div>
          <p style={{ marginTop: 0 }}>Icona Categoria:</p>

          <ImagePicker
            width={"100%"}
            height={100}
            defaultValue={icon?.url}
            onUploaded={(entry) =>
              setIcon({
                url: entry.url,
              })
            }
          />
        </div>

        <Button
          className={classes.textField}
          type="button"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          {catEditValue ? "Aggiorna" : "Crea"}
        </Button>
      </div>
    );
  }
);
